
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import StudioHeroSection from './components/StudioHeroSection';
import StudioContentSection from './components/StudioContentSection';

export default function Studio() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <StudioHeroSection />
        <StudioContentSection />
      </main>
      <Footer />
    </div>
  );
}